import { switchMap, take } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod';
import { dataAccessEnvironment } from '../../models/data-access-environment';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { postJwt } from '../authws/post-jwt';
import { routingProfileServiceEnvironment } from './routing-profile-service-environment';
import { routingProfileRequestSchema } from './schemas/request-schemas.schema';
import {
  RoutingProfile,
  routingProfileSchema,
} from './schemas/routing-profile.schema';

export function postRoutingProfile(routingProfile: RoutingProfile) {
  return postJwt({ authenticationToken: dataAccessEnvironment.authToken }).pipe(
    take(1),
    switchMap((jwt) => {
      return fromFetch(
        new Request(routingProfileServiceEnvironment.routingProfilesUrl, {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            Authorization: `bearer ${jwt.access_token}`,
          },
          body: JSON.stringify(
            routingProfileRequestSchema.parse(routingProfile)
          ),
        })
      ).pipe(
        selectData(
          z.object({
            data: routingProfileSchema,
          })
        )
      );
    })
  );
}
